// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"tj_a bik_rc bik_qx bik_xr","ForumPosts__contest":"tj_b bik_hq","ForumPosts__counselling":"tj_c"};